
export const parseError = (err) => {
    if (!err) {
        return {
            url: null,
            headers: null,
            data: null,
            status: null,
            statusText: null,
            message: 'Unknown error occurred',
            stack: null
        };
    }

    return  {
        url : err.config && err.config.url,
        headers : err.config && err.config.headers,
        data : err.response && err.response.data,
        status : err.status,
        statusText : err.statusText,
        message : err.message,
        stack : err.stack
    };
}

export const handlError = (action, err) => {
    return ({
        type : 'SERVER_ERROR',
        payload : action.payload,
        fromAction : action.type,
        txn : 'err',
        err : err
    })
}

